export default __webpack_public_path__ + "static/media/DebitEntry2.a194d7d8.svg";